import apiFetch from '../../apiFetch'

export default function (purchaseId, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/purchase/${purchaseId}`, method: 'DELETE', token: token, lastAccessDate })
}
